var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditorialChan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1414_235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.79592 9.70312H27.4898C27.9294 9.70312 28.2857 9.33938 28.2857 8.89062V6.85938C28.2857 6.41062 27.9294 6.04688 27.4898 6.04688H6.79592C6.35632 6.04688 6 6.41062 6 6.85938V8.89062C6 9.33938 6.35632 9.70312 6.79592 9.70312ZM6.79592 17.8281H27.4898C27.9294 17.8281 28.2857 17.4644 28.2857 17.0156V14.9844C28.2857 14.5356 27.9294 14.1719 27.4898 14.1719H6.79592C6.35632 14.1719 6 14.5356 6 14.9844V17.0156C6 17.4644 6.35632 17.8281 6.79592 17.8281ZM6.79592 25.9531H27.4898C27.9294 25.9531 28.2857 25.5894 28.2857 25.1406V23.1094C28.2857 22.6606 27.9294 22.2969 27.4898 22.2969H6.79592C6.35632 22.2969 6 22.6606 6 23.1094V25.1406C6 25.5894 6.35632 25.9531 6.79592 25.9531Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1414_235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2857,
    height: 26,
    fill: "currentColor",
    transform: "translate(6 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorialChan);
export default __webpack_public_path__ + "static/media/editorial_chan.b4388a625a86ea3349063af08ca6ada8.svg";
export { ForwardRef as ReactComponent };